import React from 'react'
import { Container, Nav, NavDropdown, Navbar } from "react-bootstrap";
import { useHistory } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import img2 from "../Images/logo.png";
import "bootstrap/dist/css/bootstrap.min.css";
import '../Styles/header.scss'
import { Company } from "../assets/Data";

function Header({ currentComponent, handleNavLinkClick }) {
  const history = useHistory();
  const linkStyle = {
    fontSize: 16,
  };

  const DropdownLinkStyle = {
    fontSize: 16,
    fontWeight: 400,
  };

  const CompanyData = Company[0];

  return (
    <>
      <header className="main">
        <div className="row m-0 my-3 mb-3">
          <div className="column col-md-3 col-12 p-0 d-flex justify-content-start">
            <img src={img2} className="logo" alt={CompanyData.name + "logo"} />
          </div>

          <div className="column col-md-4 col-12 justify-content-center">
            <div>
              <h1 className="pl-lg-3 headerH1 w-100">{CompanyData.name}</h1>
              <span className="tagline w-100">{CompanyData.tagline}</span>
            </div>
          </div>

          <div className="column col-md-2 col-12 my-3 d-flex justify-content-center">
            <a href="/ProductList" className="btn button">
              Product List
            </a>
          </div>

          <div className="column col-md-3 col-12  d-flex justify-content-center align-items-center">
            <Nav
              // className="d-flex linksPadding "
              navbarScroll
            >
              <NavDropdown
                title="Login As"
                style={{
                  marginRight: "20px",
                  fontSize: 16,
                }}
                align={"end"}
                id="navbarScrollingDropdown"
              >
                <NavDropdown.Item
                  style={DropdownLinkStyle}
                  onClick={() => history.push("/Customer")}
                >
                  Customer
                </NavDropdown.Item>
                <NavDropdown.Item
                  style={DropdownLinkStyle}
                  onClick={() => history.push("/Company")}
                >
                  Company
                </NavDropdown.Item>
                {/* <NavDropdown.Item
                  style={DropdownLinkStyle}
                  onClick={() => history.push("/Salesman")}
                >
                  Salesman
                </NavDropdown.Item> */}
              </NavDropdown>
            </Nav>
          </div>
        </div>
      </header>

      {/* <Navbar expand="lg" style={{ padding: 0 }}>
        <Container fluid className="navigation-bar container">
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav
              className="me-auto my-2 my-lg-0 container "
              style={{
                display: window.innerWidth < 1024 ? "flex" : "contents",
                flexDirection: "column",
                flexWrap: "nowrap",
              }}
              navbarScroll
            >
              <Nav.Link
                className={
                  (currentComponent === "Home" || currentComponent === "home"
                    ? "activeLink"
                    : "") + " menu-link linksPadding "
                }
                style={linkStyle}
                onClick={() => handleNavLinkClick("Home")}
              >
                Home
              </Nav.Link>

              <Nav.Link
                className={
                  (currentComponent === "AboutUs" ? "activeLink" : "") +
                  " menu-link linksPadding"
                }
                style={linkStyle}
                onClick={() => handleNavLinkClick("AboutUs")}
              >
                About Us
              </Nav.Link>

              <Nav.Link
                className={
                  (currentComponent === "OurVision" ? "activeLink" : "") +
                  " menu-link linksPadding"
                }
                style={linkStyle}
                onClick={() => handleNavLinkClick("OurVision")}
              >
                Our Vision
              </Nav.Link>

              <Nav.Link
                className={
                  (currentComponent === "OurValues" ? "activeLink" : "") +
                  " menu-link linksPadding"
                }
                style={linkStyle}
                onClick={() => handleNavLinkClick("OurValues")}
              >
                Our Values
              </Nav.Link>

              <Nav.Link
                className={
                  (currentComponent === "ContactUs" ? "activeLink" : "") +
                  " menu-link linksPadding"
                }
                style={linkStyle}
                onClick={() => handleNavLinkClick("ContactUs")}
              >
                Contact Us
              </Nav.Link>

              <Nav.Link
                className=" menu-link linksPadding"
                onClick={() => history.push("/ProductList")}
                style={linkStyle}
              >
                Products
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar> */}
    </>
  );
}

export default Header